import PropTypes from 'prop-types'
import { Badge } from './ui/badge'

export default function PrizeTile({ header, icon, dollarAmount }) {
  const points = dollarAmount * 100
  
  return (
    <div className="bg-white rounded-lg p-3 border border-gray-200 flex items-center w-full md:w-[280px] h-24">
      {/* Icon */}
      <div className="flex-shrink-0 mr-4">
        <img src={icon} alt={header} className="w-[60px] h-[60px]" />
      </div>
      
      {/* Content */}
      <div className="flex-1">
        <h4 className="text-sm font-semibold text-black mb-2" style={{
          fontSize: '14px',
          fontWeight: '600'
        }}>{header}</h4>
        <div className="flex items-center gap-2">
          <Badge className="text-xs">{points.toLocaleString()} pts</Badge>
          <span className="text-xs text-gray-300">(${dollarAmount.toLocaleString()})</span>
        </div>
      </div>
    </div>
  )
}

PrizeTile.propTypes = {
  header: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  dollarAmount: PropTypes.number.isRequired,
} 